<template>
    <div class="mobiledeliverylist">
        <template v-for="group in ordergroup">

            <div 
                v-if="checkhasaccepted(group)"
                :key="group.date" 
                class="deliveries">

                <b-container >
                    <template v-if="group.date == 'pastdue'">
                        <h3>Past Due</h3>
                    </template>

                    <template v-else>
                        <h3>{{group.date | formatreldate}}</h3>
                    </template>

                    <template v-for="order in group.orders">
                        
                        <div 
                            v-if="checkstatus(order, 'accepted')"
                            :key="order.order.id" 
                            class="deliveryItem">
                            
                            <div 
                                @click="viewOrder(order)" 
                                class="OrderInfo">
                                <div class="itemSize">
                                    <span class="itemNumber">
                                        {{order.order.numberofboxes}}
                                    </span>
                                    <span class="doz">
                                        DOZ
                                    </span>
                                </div>

                                <div class="orderName">
                                    <h2>{{order.order.contact_name}}</h2>
                                    <p>{{order.order.phone_number | VMask('(###) ###-####')}}</p>
                                </div>
                            </div>

                            <div class="deliveryInfo">
                                    <b-row>
                                        <b-col cols="3" md="2">
                                            <div 
                                                @click="openMap('drive', order.order)"
                                                class="googleMap">
                                                <GmapMap
                                                    :options="mapOptions"
                                                    :center="{
                                                        lat: parseFloat(order.order.shipping_address_latitude),
                                                        lng: parseFloat(order.order.shipping_address_longitude)
                                                    }"
                                                    :zoom="10"
                                                    map-type-id="roadmap"
                                                >
                                                    <GmapMarker
                                                        :icon="svgMarker"
                                                        :position="{
                                                            lat: parseFloat(order.order.shipping_address_latitude),
                                                            lng: parseFloat(order.order.shipping_address_longitude)
                                                        }"
                                                    />
                                                </GmapMap>
                                            </div>
                                        </b-col>

                                        <b-col class="pl0" cols="9" md="10">
                                            <div 
                                                @click="viewOrder(order)"
                                                class="deliveryDateandTime">
                                                <div class="ddate">
                                                    <b-icon icon="calendar"></b-icon> {{order.order.order_event_time_range ? `${order.order.order_event_time_range}, ` : ''}} {{order.order.delivery_date | formatdate('MMM D')}}
                                                </div>

                                                <div class="dAddress">
                                                    <b-icon icon="geo-alt"></b-icon> {{order.order.shipping_address_street}} {{order.order.shipping_address_city}} {{order.order.shipping_address_state}} {{order.order.shipping_address_zipcode}}
                                                </div>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                        </div>
                    </template>

                </b-container>
            </div>
        </template>

    </div>
</template>

<script>
/**
 * Declerations
 */

// mixins
// import {mapMixins} from '@/mixins/mapMixins';
// import {ordermixins} from '@/mixins/ordermixins'
import {deliverylistmixins} from '@/mixins/driverdeliverylistmixins'

//Helper
// import Helper from '@/helpers/helper'

export default {
    mixins : [deliverylistmixins],
    // props : {
    //     ordergroup : {
    //         type   : Array,
    //         default: () => []
    //     }
    // },
    // filters : {
    //     /**
    //      * Format date by 
    //      * @param format
    //      */
    //     formatdate(date, format) {
    //         return date ? Helper.formatdate(date, format) : ''
    //     },
    //     /**
    //      * Format date by relation like
    //      * Today, Tomorrow, and MM/DD/YYYY
    //      */
    //     formatreldate(date) {
    //         return Helper.datestring(date)
    //     }
    // },
    // methods : {
    //     /**
    //      * Check if group has accpeted order
    //      * @param group 
    //      */
    //     checkhasaccepted(group) {
    //         const accepted = group.orders.filter(o => o.order.status == 'accepted' || o.order.status == 'amend')

    //         return accepted.length > 0 ? true : false
    //     },
    //      /**
    //      * View order details
    //      * @param id assigned record id
    //      */
    //     viewOrder(order){
    //         this.$router.push({
    //             name : 'order',
    //             params : {id : order.id}
    //         })
    //     },
    //     /**
    //      * Check if order status is accepted
    //      * @param order
    //      * @param status
    //      */
    //     checkstatus(order, status) {
    //         if(status == 'accepted') {
    //             return order.order.status == 'accepted' || order.order.status == 'amend' ? true : false
    //         } else {
    //             return order.order.status == status ? true : false
    //         }
    //     },
    // }
}
</script>

<style>

</style>